<!-- 采购退货 -->
<template>
    <div class='page_content'>
      <processAuditAction ref="processAuditAction"></processAuditAction>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
        <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
        <div class="page_content_top_line">
          <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
        </div>
      </div>
      <div class="page_content_center">
        <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" size="mini" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
          <el-table-column label="选择操作" width="80">
            <template slot-scope="scope">
              <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                <i class="el-icon-thumb"></i>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
            :prop="tableValye.entityField" :label="tableValye.showField">
            <template slot-scope="scope">
              <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                              {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                          </span>
                          <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                              {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                          </span>
              <span v-else-if="tableValye.fieldType == 'formatter'">
                <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                  <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">{{ item.value
                                  }}</el-tag>
                </span>
              </span>
              <span v-else-if="tableValye.isRift == 1">
                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                              }}</a>
              </span>
              <span v-else>
                {{ scope.row[tableValye.entityField] }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_content_bottom">
        <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
        <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
    </div>
  </template>
  
  <script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import SearchScheme from "../../../byComponents/SearchScheme.vue";
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
      SearchScheme,
    },
    data() {
      //这里存放数据
      return {
        tableHeight: 0,
        getRequestData: {},
        returnData: {
          pages: 0, // 总页数
          total: 0, // 总条数
          pageNum: 0, // 当前页数
          list: [],
        },
        buttonList: [],
        pageShowData: [],
        selectedDataIndex: 0,
        exId: "",
        seId: "",
        ceshi: "",
        dialogTitle: "",
        seWidth: "",
        height: "",
        exTitle: "",
        seTitle: "",
        seWidth: "",
        exWidth: "",
        DialogVisible: false,
        DialogExtract: false,
        newFormDataList: [],
        seType: "",
        smId: "",
        parentSearchData: {},
        requesUrl: "",
        ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      "getRequestData.rgamRapcusName": {
        handler: function (newValue, oldValue) {
          if (newValue == "") {
            this.getRequestData.rgamRapcus = "";
          }
        },
        deep: true,
      },
    },
    //方法集合
    methods: {
      // 点击穿透字段 传参单号
      toDetail(orderId) {
        if (orderId) {
          // 设置为true 打开穿透组件首页
          var isPenetrate = true;
          // 设置缓存 存入点击单号
          this.resetSetItem("penetrateOrderId", orderId);
          // 与父级跨域通信 传递isPenetrate参数
          window.parent.postMessage(
            {
              //向窗口发送MessageEvent消息
              cmd: "returnFormJson",
              params: { isPenetrate }, //参数
            },
            "*"
          );
        }
      },
      changeInputModel(val) {
        if (val != "" || val != undefined) {
          this.DialogVisible = false;
          if (this.seType == "smId") {
            this.getRequestData.smId = val.smId;
            this.getRequestData.smName = val.smName;
          }
        }
      },
      getSeWidth(e) {
        console.log(e);
        this.seWidth = e + "%";
      },
      getWidth(e) {
        console.log(e);
        this.exWidth = e + "%";
      },
      getSearchName(e) {
        console.log(e);
        this.seTitle = e;
      },
      getExtractName(e) {
        console.log(e);
        this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
        this.DialogVisible = true;
        this.seId = sId;
        this.sField = sField;
        this.parentSearchData[type] = this.getRequestData[type];
      },
      //检索带回数据
      changeInputModel(val) {
        if (val != "" || val != undefined) {
          this.DialogVisible = false;
          this.paramValue(val);
        }
      },
      // 赋值字段
      paramValue(val) {
        let arr = this.sField.split(",");
        arr.forEach((item) => {
          this.getRequestData[item] = val[item];
        });
      },
      isShowData(name, value) {
        console.log(name);
        switch (name) {
          case "rgamRapcus":
            var dataInfo = sessionStorage.getItem("selectSupplierData");
            if (dataInfo) {
              dataInfo = JSON.parse(dataInfo);
              this.getRequestData.rgamRapcus = dataInfo.smId;
              this.getRequestData.rgamRapcusName = dataInfo.smName;
            }
            break;
          default:
            this.getRequestData[name] = value;
        }
      },
  
      // 获取数据列表
      async getPageInfo() {
        var pathId = parent.getMenuInfo(this.$route.path);
        let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
        if (responseData.status == 200) {
          this.pageShowData = responseData.result;
          var obj = {}
          if (this.pageShowData.jurHead) {
            obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
          } else {
            obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
          }
          for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
          }
          this.getDataList();
        } else {
          this.$message({
            message: responseData.message,
            type: "error",
          });
        }
      },
  
      // 动作集合
      actionSet(actionData) {
        console.log(actionData)
        if (actionData.actionType != 15 && actionData.actionType != 9) {
          if (this.returnData.list.length <= 0) {
            if (!dataInfo) {
              this.$message({
                message: "暂无数据",
                type: "error",
              });
              return false;
            }
          }
          if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
              message: "请先选择您要操作的数据",
              type: "error",
            });
            return false;
          }
          var dataInfo = JSON.parse(
            JSON.stringify(this.returnData.list[this.selectedDataIndex])
          );
        }
  
        switch (actionData.actionType) {
          case 4:
            this.$refs["processAuditAction"].openBox(0, dataInfo.appId);
            break;
          case 5:
            this.$refs["processAuditAction"].openBox(1, dataInfo.appId);
            break;
          case 7:
            this.puBackPuRgapplyGoBack()
            break;
          case 9:
            this.exportFun()
            break;
        }
      },
      async exportFun() {
        this.getRequestData.page = 1;
        await this.getDataList()
        if (this.returnData.list.length == 0) {
          this.$message({ type: 'error', message: "暂无数据！" })
          return
        }
        window.location.href = this.requesUrl + '/ReturnGoodsNotices/exportOrderHisData?ormId=' + String(this.ormId) + '&smId=' + this.getRequestData.smId
          + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
          + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows + '&origin=' + this.getRequestData.origin
          + '&smName=' + this.getRequestData.smName + '&createrName=' + this.getRequestData.createrName 
      },
      openFormDesign() {
        let pathInfo = parent.getMenuInfo(this.$route.path)
        this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
  
      // 回退
      async puBackPuRgapplyGoBack() {
        var dataInfo = this.returnData.list[this.selectedDataIndex];
        if (!dataInfo) {
          this.$message({
            message: "请先选中要操作的数据",
            type: "error",
          });
          return false;
        }
        this.$confirm("确定要回退该订单?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          let responseData = await this.$http.puBackPuRgapplyGoBack({
            ids: [dataInfo.rganomId],
          });
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: responseData.message,
            });
  
            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        }).catch(() => { });
      },
      // 数据搜索
      searchData() {
        this.getRequestData.page = 1;
        this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
        this.getRequestData.page = val;
        this.getDataList();
      },
      // 切换显示条数
      setDataPageSize(val) {
        this.getRequestData.page = 1;
        this.getRequestData.rows = val;
        this.getDataList();
      },
      // 获取数据列表
      async getDataList() {
        if (this.getRequestData.smName == "") {
          this.getRequestData.smId = "";
        }
        let responseData = await this.$http.overApplicationQueryHis(
          this.getRequestData
        );
        if (responseData.status == 200) {
          this.returnData.list = responseData.result.list;
          this.returnData.pages = responseData.result.pages;
          this.returnData.total = responseData.result.total;
          this.returnData.pageNum = responseData.result.pageNum;
          this.selectedDataIndex = 0;
        } else {
          this.$message({
            message: responseData.message,
            type: "error",
          });
        }
      },
  
      // 获取按钮权限
      async getButtonList() {
        this.buttonList = await this.$common.getActionButton()
        
      },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.getPageInfo();
      this.getButtonList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>
  <style scoped>
  .table_content_tag {
    margin-right: 1rem;
  }
  
  .el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
  }
  </style>